import footersmall from "_texts/presentation/footers/footersmall.js";

const textProps = {
  ...footersmall,
  type: "dark",
};
export default textProps;
